<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Order Case Progress</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :hideBranch="true"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_case_user_id"
              >
                <td>{{ r.order_case_id_fk }}</td>
                <td>{{ r.theOrderID }}</td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.customer_name }}</td>
                <td>{{ r.customer_phone }}</td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.sent_by }}</td>
                <td>{{ r.deadline | moment('YYYY-MM-DD hh:mm a') }}</td>
                <td>{{ r.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
                <td>
                  <div class="d-flex">
                    <comment
                      v-if="$_has_perm('comment_order_case')"
                      :modelId="r.order_case_id_fk"
                      modelName="Order Case"
                      class="px-2"
                      :title="`Order Case #${r.order_case_id_fk} Comments`"
                    />

                    <a
                      v-if="$_has_perm('send_to_staff_order_case') && [1,2].includes(r.status)"
                      tooltip="Send to staff"
                      class="px-2"
                      @click="sendToStaff(r)"
                    >
                      <v-icon color="success darken-2">send</v-icon>
                    </a>

                    <a
                      v-if="[1,2].includes(r.status)"
                      tooltip="Images"
                      class="px-2"
                      @click="showCaseFiles(r)"
                    >
                      <i
                        class="fa fa-image grey--text text--darken-2"
                        style="font-size: 22px"
                      />
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <send-to-staff
            :sendToStaffModal="sendToStaffModal"
            :formData="formData"
            :staffList="staffList"
            @close="sendToStaffModal = false"
            @resetTable="resetGetResults()"
          />

          <order-case-files
            :formData="formData"
            :orderCaseFileModal="orderCaseFileModal"
            @close="orderCaseFileModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import sendToStaff from './sendToStaff.vue'
import orderCaseFiles from './orderCaseFiles.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    sendToStaff,
    orderCaseFiles
  },

  mounted() {
    this.perPageFix()
    this.getStaffList()
    this.getWarehouses()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    let sortOrders = {}
    let columns = [
      { label: 'Case ID', text: 'Case ID', value: '1', sortable: true, searchable: true, name: 'order_case_id_fk' },
      { label: 'Order ID', text: 'Order ID', value: '2', sortable: true, searchable: true, name: 'theOrderID' },
      { label: 'Created By', text: 'Created By', value: '3', sortable: true, searchable: true, name: 'full_name' },
      { label: 'Customer Name', text: 'Customer Name', value: '4', sortable: true, searchable: true, name: 'customer_name' },
      { label: 'Customer Phone', text: 'Customer Phone', value: '5', sortable: true, searchable: true, name: 'phone_number' },
      { label: 'Product Name', text: 'Product Name', value: '6', sortable: true, searchable: true, name: 'product_name' },
      { label: 'Sent By', text: 'Sent By', value: '7', sortable: true, searchable: true, name: 'sent_by' },
      { label: 'Deadline', text: 'Deadline', value: '8', sortable: true, searchable: true, name: 'deadline' },
      { label: 'Create Date', text: 'Create Date', value: '9', sortable: true, searchable: true, name: 'created_at' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/order-case-user',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditOrderCaseModal: false,
      orderCaseFileModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      sendToStaffModal: false,
      staffList: [],
      warehouses: [],
      columns: columns,
      statusList: [
        { text: 'Pending', value: 1 },
        { text: 'Processing', value: 2 },
        { text: 'Refund', value: 3 },
        { text: 'Replace', value: 4 }
      ],
      sortKey: 'order_case_user_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_case_user_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getStaffList() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-staff-list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.forEach((c) => {
            this.staffList.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    showCaseFiles(data) {
      this.formData = {
        ...data,
        order_case_id: data.order_case_id_fk
      }
      this.orderCaseFileModal = true
    },

    sendToStaff(data) {
      this.formData = {
        order_case_id: data.order_case_id_fk,
        order_case_user_id: data.order_case_user_id,
        user_id_fk: null,
        theOrderID: data.theOrderID,
        full_name: data.full_name,
        deadline: null
      }
      this.sendToStaffModal = true
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(() => {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(error => {
          swal(`${error.response.data.message}`, '', 'error')
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'order_case_user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'order_case_user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'order_case_user_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'order_case_user_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderCase/orderCaseUsers.vue